const stats = [
  { value: '2', label: 'Core Products' },
  { value: '100%', label: 'iOS Focused' },
];

export default function AboutSection() {
  return (
    <section id="about" className="w-full bg-white py-24 md:py-36">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Top Label */}
        <div className="inline-flex items-center border border-gray-300 rounded-full px-5 py-1.5 mb-12">
          <span className="text-xs font-semibold tracking-widest uppercase text-gray-600" style={{ fontFamily: "'Inter', sans-serif" }}>
            About Us
          </span>
        </div>

        {/* Main Grid */}
        <div className="flex flex-col lg:flex-row gap-16 lg:gap-24 items-start">
          {/* Left: Text */}
          <div className="w-full lg:w-1/2">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-gray-900 leading-tight mb-8" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
              We Build
              <br />
              <span className="font-light text-gray-400">Tomorrow&apos;s Apps</span>
            </h2>
            <p className="text-base md:text-lg text-gray-600 leading-relaxed mb-8" style={{ fontFamily: "'Inter', sans-serif" }}>
              <strong>COMPANY</strong> is a team of experts developing modern applications for the iOS platform. Our products, such as <strong>VPN</strong> and <strong>Cleaner</strong>, are designed to enhance user experience and improve the security of mobile devices.
            </p>
            <p className="text-base md:text-lg text-gray-600 leading-relaxed" style={{ fontFamily: "'Inter', sans-serif" }}>
              We believe that every iOS user deserves powerful tools that are both intuitive and effective. Our engineering team combines deep platform knowledge with a passion for clean, purposeful design — delivering apps that users trust and rely on every day.
            </p>
          </div>

          {/* Right: Image + Stats */}
          <div className="w-full lg:w-1/2 flex flex-col gap-10">
            {/* Image */}
            <div className="relative w-full h-64 md:h-80 rounded-2xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/702f3d3986abe5167372a333ca767b81.jpg"
                alt="COMPANY team at work"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" />
            </div>

            {/* Stats Grid */}
            <div className="grid grid-cols-2 gap-6">
              {stats.map((stat) => (
                <div key={stat.label} className="bg-gray-50 rounded-xl p-6">
                  <div className="text-3xl md:text-4xl font-black text-gray-900 mb-1" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
                    {stat.value}
                  </div>
                  <div className="text-sm text-gray-500 font-medium uppercase tracking-wide" style={{ fontFamily: "'Inter', sans-serif" }}>
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
